module.exports = __webpack_public_path__ + "img/meme_15.e0cbf3d1.jpg";